export default {
  entries: [{
    name: "FE000000",
    link: "https://dan-simon.github.io/misc/fe000000/",
    image: "game--hex-game.png"
  },
  {
    name: "Trimps",
    link: "https://trimps.github.io/",
    image: "game--trimps.png"
  },
  {
    name: "Mine Defense",
    link: "http://scholtek.com/minedefense",
    image: "game--mine-defense.png"
  },
  {
    name: "Wizard and Minion Idle",
    link: "https://www.kongregate.com/games/Oninou/wami",
    image: "game--wami.png"
  },
  {
    name: "Anti-Idle",
    link: "https://www.kongregate.com/games/Tukkun/anti-idle-the-game",
    image: "game--anti-idle.png"
  },
  {
    name: "Synergism",
    link: "https://pseudo-corp.github.io/SynergismOfficial/",
    image: "game--synergism.png"
  },
  {
    name: "Universal Paperclips",
    link: "https://www.decisionproblem.com/paperclips/",
    image: "game--universal-paperclips.png"
  },
  {
    name: "Monies 2",
    link: "https://sneekxy.nmtechgroup.com/monies2/",
    image: "game--monies2.png"
  },
  {
    name: "The First Alkahistorian",
    link: "https://nagshell.github.io/elemental-inception-incremental/",
    image: "game--alkahistorian.png"
  },
  {
    name: "Melvor Idle",
    link: "https://melvoridle.com/",
    image: "game--melvor-idle.svg"
  }],
  selected: -1,
};
